(() => {
  if (window.spLayoutSwitch) return;
  window.spLayoutSwitch = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  const DURATION = 460;
  let replaying = false;

  const onScreen = (r) => r.bottom > 0 && r.top < window.innerHeight && r.width > 0;

  document.addEventListener('click', (evt) => {
    if (replaying) return;
    const sw = evt.target.closest && evt.target.closest('.layout-switch');
    if (!sw) return;
    if (sw.classList.contains('layout-switch--active')) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }
    if (reduce.matches || !('animate' in Element.prototype)) return;

    const scope = sw.closest('.shopify-section') || document;
    const cards = [...scope.querySelectorAll('.product-grid > .product-block')];
    if (!cards.length) return;

    evt.preventDefault();
    evt.stopPropagation();

    const first = new Map();
    let anchor = null;
    let anchorTop = 0;
    cards.forEach((card) => {
      const r = card.getBoundingClientRect();
      if (onScreen(r)) {
        first.set(card, r);
        if (!anchor && r.bottom > 80) { anchor = card; anchorTop = r.top; }
      }
    });

    cards.forEach((card) => card.getAnimations().forEach((a) => a.cancel()));
    replaying = true;
    try { sw.click(); } finally { replaying = false; }

    if (anchor) {
      const shift = anchor.getBoundingClientRect().top - anchorTop;
      if (shift) window.scrollBy({ top: shift, behavior: 'instant' });
    }

    cards.forEach((card) => {
      const last = card.getBoundingClientRect();
      if (!onScreen(last)) return;
      const was = first.get(card);
      if (was) {
        const s = was.width / last.width;
        const dx = was.left - last.left;
        const dy = was.top - last.top;
        if (Math.abs(dx) < 1 && Math.abs(dy) < 1 && Math.abs(s - 1) < 0.01) return;
        card.animate(
          [
            { transformOrigin: '0 0', transform: `translate(${dx}px, ${dy}px) scale(${s})` },
            { transformOrigin: '0 0', transform: 'none' },
          ],
          { duration: DURATION, easing: EASE }
        );
      } else {
        card.animate(
          [{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }],
          { duration: DURATION, easing: EASE, delay: 80, fill: 'backwards' }
        );
      }
    });
  }, true);
})();
